import MuiTextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import { TextFieldProps } from "@material-ui/core/TextField";
import moment from "moment";

import Info from "./Info";

type CustomTextFieldProps = TextFieldProps & {
  info?: string;
};
const TextField = (props: CustomTextFieldProps) => {
  const { info } = props;

  const formatValue = (val: any) => {
    if (props.type === "date" && val) {
      const formattedDate = moment(val).format("YYYY-MM-DD");
      return moment(formattedDate, "YYYY-MM-DD", true).isValid()
        ? formattedDate
        : "";
    }
    return val;
  };

  return (
    <MuiTextField
      type="text"
      variant="filled"
      {...props}
      value={formatValue(props.value)}
      InputProps={{
        endAdornment: info && (
          <InputAdornment position="end">
            <Info title={info} />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default TextField;
